import EquipmentsFooter from "./EquipmentsFooter";

export default EquipmentsFooter;
